import styled from "styled-components";

export default styled.input`
  width: 100%;
  color: rgb(108, 108, 108);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 5px;
  padding: 16.5px 14px;
`;
